/** Trofeos asignados a una propuesta (títulos de `ediciones.trofeos`). */

export function parsePropuestaTrofeos(value: unknown): string[] {
  if (value == null) return [];
  let arr: unknown[] = [];
  if (typeof value === 'string') {
    const t = value.trim();
    if (!t) return [];
    if (t.startsWith('[')) {
      try {
        const parsed = JSON.parse(t);
        if (Array.isArray(parsed)) arr = parsed;
        else return [t];
      } catch {
        return [t];
      }
    } else {
      return [t];
    }
  } else if (Array.isArray(value)) {
    arr = value;
  } else if (typeof value === 'number' && Number.isFinite(value)) {
    // Compat residual 1/2/3
    if (value === 1) return ['1.er lugar'];
    if (value === 2) return ['2.° lugar'];
    if (value === 3) return ['3.er lugar'];
    return [];
  } else {
    return [];
  }

  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of arr) {
    let t = String(item ?? '').trim();
    if (!t) continue;
    if (t === '1') t = '1.er lugar';
    else if (t === '2') t = '2.° lugar';
    else if (t === '3') t = '3.er lugar';
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out;
}

/** Una etiqueta para badge (varios unidos). */
export function etiquetaPropuestaTrofeos(
  ganador: unknown
): string | null {
  const list = parsePropuestaTrofeos(ganador);
  if (list.length === 0) return null;
  return list.join(' · ');
}

/** @deprecated usar etiquetaPropuestaTrofeos / parsePropuestaTrofeos */
export function etiquetaPropuestaTrofeo(
  ganador: string | number | null | undefined | unknown
): string | null {
  return etiquetaPropuestaTrofeos(ganador);
}

/** @deprecated usar parsePropuestaTrofeos */
export function parsePropuestaTrofeo(value: unknown): string | null {
  const list = parsePropuestaTrofeos(value);
  return list[0] ?? null;
}

/** @deprecated usar etiquetaPropuestaTrofeos */
export function etiquetaPropuestaGanador(
  ganador: string | number | null | undefined | unknown
): string | null {
  return etiquetaPropuestaTrofeos(ganador);
}
